import { useState } from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Sidebar from "../../sidebar/sidebar";
import { useAppStore } from "../../../appStore";
import OnlineTransfer from "./components/onlineTransfer";
import OfflineTransfer from "./components/offlineTransfer";
import GroupTransferSimple from "./components/groupTransfer";
import FloatingCard from "../../FloatingCard/floatingMenu";
import MobileFloatingSpacer from "../../FloatingCard/MobileFloatingSpacer";

const disabledTransferContent = (title, message) => (
  <Card
    sx={{
      maxWidth: 500,
      mx: "auto",
      mt: 4,
      p: 2,
      backgroundColor: "#fff3e0",
      borderLeft: "6px solid #ff9800",
      boxShadow: 3,
      borderRadius: 2,
    }}
  >
    <CardContent sx={{ textAlign: "center" }}>
      <WarningAmberIcon sx={{ fontSize: 50, color: "#ff9800" }} />
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", mt: 2, color: "#e65100" }}
      >
        {title} Disabled
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, color: "#795548" }}>
        {message}
      </Typography>
    </CardContent>
  </Card>
);

function HwlMobileTransferPage() {
  const { profileData } = useAppStore();
  const [selectedTab, setSelectedTab] = useState(0);
  const showOfflineTransfer = profileData?.offlineTansferStatus === "active";
  const showGroupTransfer = profileData?.groupTansferStatus === "active";

  const transferTabs = [
    {
      label: "ID Transfer",
      content:
        profileData?.walletTansferStatus === "inactive" ? (
          disabledTransferContent(
            "ID Transfer",
            <>
              Your ID wallet transfer is currently <strong>inactive</strong>.
              Please contact your administrator for help or to reactivate
              access.
            </>,
          )
        ) : (
          <OnlineTransfer />
        ),
    },
    ...(showOfflineTransfer
      ? [{ label: "Offline Transfer", content: <OfflineTransfer /> }]
      : []),
    ...(showGroupTransfer
      ? [{ label: "Group Transfer", content: <GroupTransferSimple /> }]
      : []),
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          p: 1,
          background: `url(${process.env.PUBLIC_URL}/images/logo-background.png) center/250px no-repeat fixed`,
          minHeight: "100vh",
        }}
      >
        <Box height={60} />
        <FloatingCard />
        {transferTabs.length > 1 && (
          <Tabs
            value={selectedTab}
            onChange={(_, value) => setSelectedTab(value)}
            variant="fullWidth"
            sx={{
              // borderBottom: 1,
              borderColor: "#1e2466",
              "& .MuiTabs-indicator": {
                backgroundColor: "#1e2466",
              },
              "& .MuiTab-root": {
                color: "#1e2466",
              },
              "& .Mui-selected": {
                color: "#1e2466 !important",
              },
            }}
          >
            {transferTabs.map((tab) => (
              <Tab
                sx={{ fontWeight: "bold" }}
                key={tab.label}
                label={tab.label}
              />
            ))}
          </Tabs>
        )}
        <Box sx={{ pt: 1 }}>{transferTabs[selectedTab]?.content}</Box>
        <MobileFloatingSpacer />
      </Box>
    </Box>
  );
}

export default HwlMobileTransferPage;
